export default __webpack_public_path__ + "static/media/pay_refunding.4e5e5a35.svg";